import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Handles Google OAuth callback from Emergent Auth.
 * URL arrives as: /dashboard#session_id=xxx
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        // Remove hash and go to next step
        window.history.replaceState(null, "", "/dashboard");
        if (!data.business) nav("/business-setup", { replace: true });
        else nav("/dashboard", { replace: true });
      } catch (e) {
        nav("/login", { replace: true });
      }
    })();
  }, [location.hash, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-nexa-bg">
      <div className="flex items-center gap-3 text-nexa-mute">
        <Loader2 className="w-5 h-5 animate-spin" />
        <span>Signing you in with Google…</span>
      </div>
    </div>
  );
}
